export default "__VITE_ASSET__CKRBDa1e__"